import { StepForm } from '@iq-firebolt/client'
import fireboltBlueberry from '@iq-firebolt/blueberry-theme'

import ActionButtons from 'components/common/ActionButtons'
import FormContainer from 'components/common/FormContainer'
import StepTitle from 'components/common/StepTitle'
import RequiredFieldsDisclaimer from 'components/common/RequiredFieldsDisclaimer'

import useStepTemplate from 'hooks/useStepTemplate'

const DefaultFormStep = ({
  fireboltStep,
  beforeSubmitStep,
  friendlyTitle,
  customGoBack,
  autoFill = {},
}) => {
  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
    beforeSubmitStep,
    customGoBack,
  })

  return (
    <FormContainer>
      {friendlyTitle ? <StepTitle>{friendlyTitle}</StepTitle> : null}
      <RequiredFieldsDisclaimer />

      <StepForm
        autoFill={{ ...autoFill }}
        theme={fireboltBlueberry}
        customActionsChild={({ formData }) => (
          <ActionButtons
            formData={formData}
            onGoBack={handleGoBackform}
            beforeSubmitStep={runBeforeChangeStep}
          />
        )}
      />
    </FormContainer>
  )
}

export default DefaultFormStep
